<template>
  <div class="mySwiper1">
    <swiper
      ref="mySwiper"
      :options="swiperOptions"
      :key="swiperKey"
      @slide-change="handleSlideChange"
    >
      <swiper-slide
        class="swiper-item"
        v-for="(item, index) in swiperList"
        :key="index"
      >
        <img v-if="item" class="item-img" :src="item" alt="" />
      </swiper-slide>
    </swiper>
    <div class="swiper-button-next" v-if="swiperList.length > 1"></div>
    <div class="swiper-button-prev" v-if="swiperList.length > 1"></div>
    <div class="swiper-dots">
      <div
        class="swiper-pagination-bullet"
        v-for="(item, idx) in swiperList"
        :key="idx"
        :class="activeIdx === idx ? 'swiper-pagination-bullet-active' : ''"
        @click="onClickDot(idx)"
      ></div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  name: "optionalSwiper",
  components: {
    swiper,
    swiperSlide,
  },
  props: {
    swiperList: {
      type: Array,
      default: function() {
        return [];
      },
    },
    showIcon: true,
  },
  data() {
    return {
      swiperOptions: {
        loop: true,
        // pagination: {
        //   el: ".swiper-pagination",
        // },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      activeIdx: 0,
      swiperKey: Math.random()
        .toString(36)
        .substr(2),
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.swiperList.length < 2) {
        this.swiperKey = Math.random()
          .toString(36)
          .substr(2);
      }
    });
  },

  methods: {
    handleSlideChange() {
      let {
        mySwiper: { swiper },
      } = this.$refs;
      this.activeIdx = swiper.realIndex;
    },
    onClickDot(idx) {
      let {
        mySwiper: { swiper },
      } = this.$refs;
      swiper.slideTo(idx + 1, 1000);
    },
  },
  watch: {
    swiperList: {
      handler(newValue, oldValue) {
        this.swiperKey = Math.random()
          .toString(36)
          .substr(2);
        this.activeIdx = 0;
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@style/base";
@import "@style/common";
$themeColor: #00b9ef;
::v-deep .swiper-container {
  height: 100%;
}
.mySwiper1 {
  width: 100%;
  height: 100%;
  position: relative;
  .item-img {
    width: 100%;
    height: 100%;
    object-fit: contain; // cover
    object-position: center;
    max-width: 100%;
  }
  .swiper-pagination {
    bottom: 16px;
    width: 100%;
    text-align: center;
  }
  .swiper-dots {
    width: 100%;
    position: absolute;
    bottom: 60px;
    text-align: center;
    z-index: 9;
    @include media(
      (
        $md: (
          display: none,
        ),
      )
    );
    .swiper-pagination-bullet {
      width: 5px;
      height: 5px;
      background: #d2d2d2;
      opacity: 1;
      &.swiper-pagination-bullet-active {
        width: 10px;
        background: $themeColor;
        border-radius: 3px;
      }
      &.swiper-pagination-bullet {
        margin-left: 5px;
      }
    }
  }
}

.swiper-button-prev {
  width: 40px;
  height: 40px;
  cursor: pointer;
  background: url(https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud%2FbackendUpload%2F20200521210305060-web_lb_80_80_left_hover%402x.png)
    no-repeat center center/cover;
  z-index: 2;
  position: absolute;
  top: 50%;
  left: 40px;
  transform: translateY(-50%);
  opacity: 0.7;
  &:hover {
    opacity: 1;
  }
  @include media(
    (
      $md: (
        display: none,
      ),
    )
  );
}
.swiper-button-next {
  width: 40px;
  height: 40px;
  cursor: pointer;
  background: url(https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud%2FbackendUpload%2F20200521210305060-web_lb_80_80_right_hover%402x.png)
    no-repeat center center/cover;
  z-index: 2;
  position: absolute;
  top: 50%;
  right: 40px;
  transform: translateY(-50%);
  opacity: 0.7;
  &:hover {
    opacity: 1;
  }
  @include media(
    (
      $md: (
        display: none,
      ),
    )
  );
}
</style>
